<script setup></script>
<template>
  <i class="fa-solid fa-bars"></i>
</template>
